<template>
  <MainLayout :initialDrawerExpanded="false" contentClass="pa-0" :has-sidebar="false">
    <template #header>
      <div class="overline">
        <PageBack />
      </div>
    </template>

    <template #content>
      <SupportHero compact title="Questions fréquentes" icon="mdi-frequently-asked-questions" />
      <div class="pa-4">
      <v-alert v-if="!item" type="error" text class="ma-4">
        Cette question n'existe pas.
        <router-link to="/faq">Voir toutes les questions</router-link>
      </v-alert>

      <div v-else class="faq-detail mx-auto pa-2">
        <v-chip small outlined class="mb-2" :to="{ name: 'faq', query: { category: item.category } }">
          <v-icon left small>{{ category.icon }}</v-icon>{{ category.title }}
        </v-chip>
        <h1 class="mb-4">{{ item.question }}</h1>
        <FaqAnswer :source="item.answer" />

        <v-card outlined class="pa-4 mt-6 d-flex align-center flex-wrap">
          <div class="flex-grow-1 mr-4">
            <div class="subtitle-1 font-weight-medium">Cette réponse ne résout pas votre problème ?</div>
            <div class="caption grey--text">L'équipe support peut vous aider directement.</div>
          </div>
          <v-btn color="primary" elevation="0" @click="showNew = true">
            <v-icon left>mdi-plus</v-icon>Ouvrir un ticket
          </v-btn>
        </v-card>

        <template v-if="related.length">
          <h3 class="mt-6 mb-3">Questions liées</h3>
          <v-row>
            <v-col v-for="r in related" :key="r.slug" cols="12" md="6">
              <FaqCard :item="r" />
            </v-col>
          </v-row>
        </template>
      </div>
      <SupportNewDialog v-model="showNew" />
      </div>
    </template>
  </MainLayout>
</template>

<script>
import PageBack from '@/components/ui/PageBack.vue'
import MainLayout from '@/layout/MainLayout.vue'
import SupportHero from '@/components/support/SupportHero.vue'
import FaqCard from '@/components/support/FaqCard.vue'
import FaqAnswer from '@/components/support/FaqAnswer.vue'
import SupportNewDialog from '@/components/support/SupportNewDialog.vue'
import { faqBySlug, faqCategory } from '@/content/faq'

export default {
  name: 'FaqDetailView',
  components: { PageBack, SupportHero, MainLayout, FaqCard, FaqAnswer, SupportNewDialog },
  data: () => ({ showNew: false }),
  computed: {
    item() {
      return faqBySlug(this.$route.params.slug)
    },
    category() {
      return faqCategory(this.item.category)
    },
    related() {
      return ((this.item && this.item.related) || []).map(faqBySlug).filter(Boolean)
    },
  },
}
</script>

<style scoped>
.faq-detail {
  max-width: 800px;
}
</style>
